import { render, staticRenderFns } from "./crm-debug-tab.vue?vue&type=template&id=346489a0&scoped=true&"
import script from "./crm-debug-tab.vue?vue&type=script&lang=js&"
export * from "./crm-debug-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346489a0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346489a0')) {
      api.createRecord('346489a0', component.options)
    } else {
      api.reload('346489a0', component.options)
    }
    module.hot.accept("./crm-debug-tab.vue?vue&type=template&id=346489a0&scoped=true&", function () {
      api.rerender('346489a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-crm-app/rfi_process/tabs/crm-debug/crm-debug-tab.vue"
export default component.exports